import Ajax from './ajax';
import { jsToFormData } from "@/utils/func";

export const pracGetSign = data => Ajax.get(`/v1-own-student-prac-get-sign`, null); //获取报名记录
export const pracGet = data => Ajax.get(`/v1-own-student-prac-get`, null); //获取开放报名中的实践考核
export const pracGetProfession = data => Ajax.get(`/v1-own-student-prac-get-profession`, data); //获取可报名专业
export const pracGetProCourse = data => Ajax.get(`/v1-own-student-prac-get-pro-course`, data); //获取专业下可报考课程
export const pracSubmitSign = data => Ajax.post(`/v1-own-student-prac-submit-sign`, jsToFormData(data));  //实际考核报名
export const designGet = data => Ajax.get(`/v1-own-student-design-get`, null); //获取开放报名中的毕业设计
export const pracDelSign = data => Ajax.post(`/v1-own-student-prac-del-sign`, jsToFormData(data));  //删除实际考核报名记录
export const pracPostDeSign = data => Ajax.post(`/v1-own-student-prac-up-design`, jsToFormData(data));  //上传设计稿
export const pracGetCnki = data => Ajax.get(`/v1-own-student-prac-get-cnki`, data); //查重记录获取
export const pracUpCnki = data => Ajax.post(`/v1-own-student-prac-up-cnki`, jsToFormData(data));  //上传查重文件
export const pracGetDupUrl = data => Ajax.get(`/v1-own-student-prac-get-dup-url`, data); //获取查重检测地址


